var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwapWithBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#E5B909",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.3818 25.1132C16.7367 25.1132 16.2144 25.6432 16.2144 26.2979L15.8926 32.0213C15.8926 32.8557 16.5597 33.5313 17.3818 33.5313C18.204 33.5313 18.8696 32.8557 18.8696 32.0213L18.5492 26.2979C18.5492 25.6432 18.027 25.1132 17.3818 25.1132Z",
    fill: "#E5B910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9755 13.5918C18.9755 13.5918 18.6405 13.2474 18.4327 13.0974C18.1314 12.8658 17.7598 12.75 17.3897 12.75C16.9742 12.75 16.588 12.8807 16.2735 13.1271C16.2164 13.185 15.9736 13.4033 15.7732 13.6067C14.5151 14.7959 12.4567 17.9003 11.8277 19.526C11.7282 19.7725 11.5132 20.3961 11.5 20.7301C11.5 21.0478 11.5702 21.3537 11.7136 21.6432C11.914 22.0054 12.2285 22.2964 12.6001 22.4553C12.8576 22.5577 13.6285 22.7166 13.6432 22.7166C14.4873 22.8769 15.8595 22.9631 17.375 22.9631C18.8189 22.9631 20.1341 22.8769 20.9913 22.7463C21.006 22.7314 21.9627 22.5726 22.2919 22.3974C22.8917 22.0782 23.2647 21.4546 23.2647 20.788V20.7301C23.2501 20.2951 22.877 19.3805 22.8639 19.3805C22.2348 17.8424 20.276 14.8107 18.9755 13.5918Z",
    fill: "#E5B910"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M30.6181 22.887C31.2633 22.887 31.7855 22.357 31.7855 21.7022L32.1059 15.9787C32.1059 15.1443 31.4403 14.4688 30.6181 14.4688C29.796 14.4688 29.1289 15.1443 29.1289 15.9787L29.4507 21.7022C29.4507 22.357 29.973 22.887 30.6181 22.887Z",
    fill: "#E5B910"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2855 26.3565C36.0851 25.9943 35.7706 25.7047 35.399 25.5444C35.1415 25.4419 34.3691 25.2831 34.3559 25.2831C33.5118 25.1227 32.1396 25.0366 30.624 25.0366C29.1802 25.0366 27.865 25.1227 27.0077 25.2534C26.9931 25.2682 26.0364 25.4286 25.7072 25.6023C25.106 25.9215 24.7344 26.5451 24.7344 27.2132V27.2711C24.749 27.7061 25.1206 28.6192 25.1352 28.6192C25.7643 30.1574 27.7216 33.1906 29.0236 34.4081C29.0236 34.4081 29.3586 34.7525 29.5664 34.901C29.8663 35.1341 30.2378 35.2499 30.6109 35.2499C31.0249 35.2499 31.4096 35.1192 31.7256 34.8728C31.7827 34.8149 32.0255 34.5966 32.2259 34.3947C33.4826 33.204 35.5423 30.0995 36.1699 28.4752C36.2709 28.2287 36.4859 27.6037 36.4991 27.2711C36.4991 26.9519 36.4289 26.646 36.2855 26.3565Z",
    fill: "#E5B910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapWithBg);
export default __webpack_public_path__ + "static/media/swap-with-bg.a51881e676afed655a79dd5ffaf72b6b.svg";
export { ForwardRef as ReactComponent };